<template>
  <div class="content">
    <el-row>
      <el-col :span="5" style="min-height: 400px; background: #fff">
        <div>
          <el-tree
            :data="treeData"
            default-expand-all
            check-strictly
            :expand-on-click-node="false"
            node-key="nodeId"
            ref="tree"
            highlight-current
            :props="defaultProps"
            @node-click="handleCheckChange"
          ></el-tree>
        </div>
      </el-col>
      <el-col :span="19">
        <div style="padding-left: 20px">
          <div
            style="padding: 100px 0; text-align: center"
            v-if="list.length == 0"
          >
            <img src="@/assets/img/kong.png" width="100px" />
            <p style="padding-top: 50px">暂无数据</p>
          </div>
          <ul>
            <li
              @click="changeVideo(item)"
              style="margin-bottom: 20px; background: #fff; padding: 15px"
              class="item"
              v-for="(item, index) in list"
              :key="index"
            >
              <el-row>
                <el-col :span="6">
                  <div style="width: 100%; height: 150px; background: #ddd">
                    <img
                      :src="'/attachmentDir/' + item.coverPictureFiles"
                      width="100%"
                      height="100%"
                    />
                  </div>
                </el-col>
                <el-col :span="18">
                  <div style="padding-left: 20px">
                    <div
                      class="title"
                      style="
                        font-size: 20px;
                        margin-bottom: 10px;
                        color: #1890ff;
                        text-decoration: underline;
                      "
                    >
                      {{ item.resourceTitle }}
                    </div>
                    <div
                      class="synopsis beyondEllipsis3"
                      style="
                        margin-bottom: 10px;
                        line-height: 30px;
                        font-size: 14px;
                        height: 85px;
                      "
                      :title="item.resourceContent"
                    >
                      简介：{{ item.resourceContent }}
                    </div>
                    <div style="font-size: 14px; color: rgb(153, 153, 153)">
                      <span>来源：</span>
                      <span style="margin-right: 30px">{{
                        ["资源中心", "行业动态", "学习中心"][item.channel]
                      }}</span>
                      <span>发布时间</span>
                      ：{{ item.createDate }}
                    </div>
                  </div>
                </el-col>
              </el-row>
            </li>
          </ul>
          <el-pagination
            background
            v-if="list.length > 0"
            style="text-align: right; background: #fff"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageNo"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="totalCount"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>
    <login-view ref="loginView" :cancel="false" />
  </div>
</template>

<script>
import { resourceQy, videoResourceQy, login } from "@/api/home";
import loginView from "@/components/loginView";
export default {
  data() {
    return {
      input: "",
      list: [],
      treeData: [],
      defaultProps: {
        children: "children",
        label: "nodeName",
      },
      pageNo: 1,
      pageSize: 10,
      resourceClassId: "0",
      retrieveArg: "",
    };
  },
  components: {
    loginView,
  },
  mounted() {
    this.getTree();
    this.getList();
  },
  methods: {
    changeVideo(item) {
      login({ op: "getSessionUser" })
        .then((response) => {
          if (!response) {
            this.$refs.loginView.show();
          } else {
            this.changeVideo2(item);
          }
        })
        .catch((error) => {});
    },
    changeVideo2(item) {
      let routerJump;
      routerJump = this.$router.resolve({
        name: "videoPlay",
        query: {
          id: this.$route.query.id,
          url: item.attachment.filesName,
          resourceClassId: this.resourceClassId,
          name: item.resourceTitle,
          resourceId: item.resourceId,
        },
      });
      window.open(routerJump.href, "_blank");

      // this.$router.push({
      //   path: "/videoPlay",
      //   query: {
      //     id: this.$route.query.id,
      //     url: item.attachment.filesName,
      //     resourceClassId: this.resourceClassId,
      //     name: item.resourceTitle,
      //     resourceId: item.resourceId
      //   }
      // });
    },
    change(val) {
      this.retrieveArg = val;
      this.pageNo = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageNo = val;
      this.getList();
    },
    getList() {
      videoResourceQy({
        op: "findPageVideoResource",
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        resourceClassId: this.resourceClassId,
        retrieveArg: this.retrieveArg,
      }).then((res) => {
        this.totalCount = res.totalCount;
        this.list = res.result || [];
        this.list.map((res) => {
          let objE = document.createElement("div");
          objE.innerHTML = res.resourceContent;
          res.resourceContent = objE.innerText;
        });
      });
    },
    handleCheckChange(val) {
      this.pageNo = 1;
      this.resourceClassId = val.nodeId;
      this.getList();
      console.log(val);
    },
    getTree() {
      resourceQy({ op: "findTreeResourceClass" }).then((res) => {
        const data = [
          {
            nodeName: "资源中心",
            nodeId: "0",
            children: res,
          },
        ];

        this.treeData = data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  margin: 0 auto;

  .item:hover {
    background: #f9f9f9;
    cursor: pointer;
  }
}

/deep/.el-tree {
  .el-icon-caret-right {
    font-size: 25px;
    color: #fff;
    display: none;
  }
  .el-tree-node__content {
    height: 48px;
    padding-left: 60px !important;
    background: rgb(237, 237, 237);
    margin-bottom: 5px;
  }

  & > .el-tree-node {
    & > .el-tree-node__children {
      .is-current {
        .el-tree-node__content {
          border-right: 5px solid #4491dc;
        }
      }
    }
    & > .el-tree-node__content {
      background: url(~@/assets/img/leftNav.png) no-repeat;
      background-size: 100% 100%;
      padding-left: 15px !important;
      .el-tree-node__label {
        font-size: 18px;
      }
      color: #fff;
      .el-icon-caret-right {
        display: inline-block;
      }
    }
  }
}
</style>